import React, { useMemo } from "react";
import { useForm } from "react-hook-form";
import {
  BROADCAST_MIN_SCHEDULED_TIME_MINUTES,
  BROADCAST_SEND_TYPE,
} from "../constants/broadcast";
import { scheduleBroadcastSchema } from "../shemas/broadcast";
import { SelectTagWidgetContainer } from "../../BroadcastView.styles";
import {
  BroadcastAppCard,
  ClockIcon,
  ContainerActions,
  DateInput,
  DateTimeContainer,
  FormContainer,
  FormInputError,
  ScheduleContainer,
  Select,
  SelectContainer,
  SelectLabel,
  TimeInput,
  TipPanel,
  TipText,
  TipTitle,
} from "../styles";
import { BackLink } from "../../Campaigns.style";
import Button from "../../../../../components/shared/components/button/Button.style";

export const ScheduleBroadcastForm = ({
  handleNext,
  handleBack,
  updateBroadcastData,
  broadcastData,
}) => {
  const { register, handleSubmit, errors, watch } = useForm({
    validationSchema: scheduleBroadcastSchema,
    defaultValues: {
      sendType: broadcastData?.sendType || BROADCAST_SEND_TYPE.NOW,
      scheduledDate: broadcastData?.scheduledDate,
      scheduledTime: broadcastData?.scheduledTime,
    },
    mode: "onChange",
  });

  const onSubmit = (data) => {
    updateBroadcastData({
      sendType: data.sendType,
      scheduledDate: data.scheduledDate,
      scheduledTime: data.scheduledTime,
    });
    handleNext();
  };

  const handleOnBack = () => {
    updateBroadcastData({
      sendType: BROADCAST_SEND_TYPE.NOW,
      scheduledDate: undefined,
      scheduledTime: undefined,
    });
    handleBack();
  };

  const sendType = watch("sendType");
  const scheduledDate = watch("scheduledDate");

  const minDate = useMemo(() => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }, []);

  const minTime = useMemo(() => {
    if (scheduledDate !== minDate) {
      return undefined;
    }

    const now = new Date();
    const futureTime = new Date(
      now.getTime() + BROADCAST_MIN_SCHEDULED_TIME_MINUTES * 60000,
    );

    return `${String(futureTime.getHours()).padStart(2, "0")}:${String(futureTime.getMinutes()).padStart(2, "0")}`;
  }, [scheduledDate, minDate]);

  return (
    <SelectTagWidgetContainer>
      <BroadcastAppCard>
        <ScheduleContainer>
          <FormContainer onSubmit={handleSubmit(onSubmit)}>
            <SelectContainer>
              <SelectLabel htmlFor="sendType">Tipo de envío</SelectLabel>

              <Select name="sendType" ref={register}>
                <option value={BROADCAST_SEND_TYPE.NOW}>Enviar ahora</option>

                <option value={BROADCAST_SEND_TYPE.SCHEDULED}>Programar</option>
              </Select>

              {errors.sendType && (
                <FormInputError>{errors.sendType.message}</FormInputError>
              )}
            </SelectContainer>

            {sendType === BROADCAST_SEND_TYPE.SCHEDULED && (
              <DateTimeContainer>
                <SelectContainer>
                  <SelectLabel htmlFor="scheduledDate">Fecha</SelectLabel>

                  <DateInput
                    type="date"
                    name="scheduledDate"
                    ref={register}
                    placeholder="Selecciona fecha"
                    min={minDate}
                  />

                  {errors.scheduledDate && (
                    <FormInputError>
                      {errors.scheduledDate.message}
                    </FormInputError>
                  )}
                </SelectContainer>

                <SelectContainer>
                  <SelectLabel htmlFor="scheduledTime">Hora</SelectLabel>

                  <TimeInput
                    type="time"
                    name="scheduledTime"
                    ref={register}
                    placeholder="HH:mm"
                    min={minTime}
                  />

                  {errors.scheduledTime && (
                    <FormInputError>
                      {errors.scheduledTime.message}
                    </FormInputError>
                  )}
                </SelectContainer>
              </DateTimeContainer>
            )}
          </FormContainer>

          <TipPanel>
            <TipTitle>
              <ClockIcon />
              Consejo
            </TipTitle>

            <TipText>
              Envía cuando tus clientes suelen responder (10:00-13:00). Evita
              horarios extremos.
            </TipText>
          </TipPanel>
        </ScheduleContainer>

        <ContainerActions>
          <BackLink onClick={handleOnBack}>← Atrás</BackLink>

          <Button designV4 onClick={handleSubmit(onSubmit)}>
            Continuar
          </Button>
        </ContainerActions>
      </BroadcastAppCard>
    </SelectTagWidgetContainer>
  );
};
